import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceTax from './ServiceTax'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'servicetax',
    component: ServiceTax,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
